import { createSlice } from "@reduxjs/toolkit";
import { sendConfirmationCode } from './actions';

export const initialState = {
  loading: false
};

const slice = createSlice({
  name: 'confirmations',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(sendConfirmationCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendConfirmationCode.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendConfirmationCode.rejected, (state) => {
        state.loading = false;
      })
  }
})

export default slice.reducer;